import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';
import * as i0 from "@angular/core";
export class DragAndDropDirective {
  fileOver = false;
  isFolderUpload = false;
  fileDropped = new EventEmitter();
  // Dragover listener
  onDragOver(evt) {
    // No matching event Type found
    //eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    evt.preventDefault();
    //eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    evt.stopPropagation();
    this.fileOver = true;
  }
  // Dragleave listener
  onDragLeave(evt) {
    // No matching event Type found
    //eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    evt.preventDefault();
    //eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    evt.stopPropagation();
    this.fileOver = false;
  }
  // Drop listener
  async ondrop(evt) {
    // No matching event Type found
    //eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    evt.preventDefault();
    //eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    evt.stopPropagation();
    this.fileOver = false;
    this.fileDropped.emit(await this.getAllFileEntries(evt.dataTransfer?.items));
  }
  // Drop handler function to get all files
  async getAllFileEntries(dataTransferItemList) {
    if (!dataTransferItemList) {
      return [];
    }
    const fileEntries = [];
    // Use BFS to traverse entire directory/file structure
    // Using any to allow for multiple types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const queue = [];
    this.addItemsToQueue(dataTransferItemList, queue);
    while (queue.length > 0) {
      // has to be any to allow for multiple types
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const entry = queue.shift();
      // has to be any to allow for multiple types
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (entry?.isFile) {
        fileEntries.push(entry);
        // has to be any to allow for multiple types
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      } else if (entry?.isDirectory) {
        queue.push(
        // has to be any to allow for multiple types
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        ...(await this.readAllDirectoryEntries(entry.createReader())));
      }
    }
    const files = [];
    for (const element of fileEntries) {
      // has to be any to allow for multiple types
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const fEntry = element;
      if (fEntry) {
        const mappedFile = await this.getFile(fEntry);
        if (mappedFile) {
          // has to be any to allow for multiple types
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment
          const fileName = fEntry?.['name'] || '';
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment
          const filePath = fEntry?.['fullPath'] || '';
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          const file = new File([mappedFile], this.isFolderUpload ? filePath : fileName);
          files.push(file);
        }
      }
    }
    return files;
  }
  // Using any to allow for multiple types
  addItemsToQueue(dataTransferItemList, queue) {
    // Unfortunately dataTransferItemList is not iterable i.e. no forEach
    for (let i = 0; i < dataTransferItemList.length; i++) {
      queue.push(dataTransferItemList[i].webkitGetAsEntry());
    }
  }
  // Get all the entries (files or sub-directories) in a directory
  // by calling readEntries until it returns empty array
  async readAllDirectoryEntries(directoryReader) {
    const entries = [];
    // has to be any to allow for multiple types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let readEntries = await this.readEntriesPromise(directoryReader);
    // has to be any to allow for multiple types
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    while (readEntries.length > 0) {
      // has to be any to allow for multiple types
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      entries.push(...readEntries);
      readEntries = await this.readEntriesPromise(directoryReader);
    }
    // has to be any to allow for multiple types
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return entries;
  }
  // Wrap readEntries in a promise to make working with readEntries easier
  // readEntries will return only some of the entries in a directory
  // e.g. Chrome returns at most 100 entries at a time
  async readEntriesPromise(directoryReader) {
    try {
      return await new Promise((resolve, reject) => {
        directoryReader.readEntries(resolve, reject);
      });
    } catch (err) {
      console.log(err);
      return await new Promise(() => undefined);
    }
  }
  async getFile(fileEntry) {
    try {
      return await new Promise((resolve, reject) => fileEntry.file(resolve, reject));
    } catch (err) {
      console.log(err);
      return await new Promise(() => undefined);
    }
  }
  static ɵfac = function DragAndDropDirective_Factory(t) {
    return new (t || DragAndDropDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DragAndDropDirective,
    selectors: [["", "geauiDragAndDrop", ""]],
    hostVars: 2,
    hostBindings: function DragAndDropDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("dragover", function DragAndDropDirective_dragover_HostBindingHandler($event) {
          return ctx.onDragOver($event);
        })("dragleave", function DragAndDropDirective_dragleave_HostBindingHandler($event) {
          return ctx.onDragLeave($event);
        })("drop", function DragAndDropDirective_drop_HostBindingHandler($event) {
          return ctx.ondrop($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵclassProp("fileover", ctx.fileOver);
      }
    },
    inputs: {
      isFolderUpload: "isFolderUpload"
    },
    outputs: {
      fileDropped: "fileDropped"
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DragAndDropDirective, [{
    type: Directive,
    args: [{
      selector: '[geauiDragAndDrop]'
    }]
  }], null, {
    fileOver: [{
      type: HostBinding,
      args: ['class.fileover']
    }],
    isFolderUpload: [{
      type: Input
    }],
    fileDropped: [{
      type: Output
    }],
    onDragOver: [{
      type: HostListener,
      args: ['dragover', ['$event']]
    }],
    onDragLeave: [{
      type: HostListener,
      args: ['dragleave', ['$event']]
    }],
    ondrop: [{
      type: HostListener,
      args: ['drop', ['$event']]
    }]
  });
})();
